import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { message, DatePicker, Row, Col, Select, Form, Input, InputNumber, Upload, Space, Button as BTN, Switch, Textarea } from 'antd';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { app } from '../../config';
import getHeaders from '../../utils/authHeaders';
import { LeftCircleOutlined, LoadingOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import InputMask from 'react-input-mask';
import getAllProductCategories from '../../hooks/getAllProductCategories';
import AddPhoto from '../../assets/images/add.png';
import useFetchBoxTypes from '../../hooks/fetchBoxTypes';
// import { AddRecord } from '../../layouts/AddRecord';
import { InputField, SelectField, TextAreaField } from '../../layouts/FormFields';
import TagInput from './TagInput';

const AddProductsPrev = () => {
  const { TextArea } = Input;
  const { t } = useTranslation(['common']);
  const [adddescriptionResp, setAddDescriptionResp] = useState({});
  const [addUserResp, setAddUserResp] = useState({});
  const [uploadedImg, setUploadedImg] = useState('');
  const [imageuploading, setImageUploading] = useState(false);
  const [uploadLogo, setuploadLogo] = useState(true);
  const [uploadVideo, setuploadVideo] = useState('  ');
  const [uplVid, setuplVid] = useState(true);
   const [tags, setTags] = useState([]);
  const [customURL, setCustomURL] = useState(false);
  const [largeFile, setLargeFile] = useState(false);
  const [contentType, setContentType] = useState();
  const [errorObj, setErrorObj] = useState({});
  const [resetModal, setResetModal] = useState(false);
  const [customVideoURL, setCustomVideoURL] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isActive, setisActive] = useState(false);
  const [uploadObj, setUploadObj] = useState({});
  const [prodType, setProdType] = useState('');
  // const [value, setValue] = useState(1);
  let navigate = useNavigate();
  let header = getHeaders();
  const productCategoriesRes = getAllProductCategories();
  console.log(productCategoriesRes);
  const boxTypeRes = useFetchBoxTypes();
  let boxTypes = [];
  boxTypeRes.response ? (boxTypes = boxTypeRes.response.data) : [];
  console.log(boxTypes);

  const productCategories = productCategoriesRes.response ? productCategoriesRes.response.data : [];
  console.log(productCategories);
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      console.log('uploading data');
      setUploadedImg('');
      setImageUploading(true);
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      setLargeFile(false);
      console.log(info.file.response);
      info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
      info.file ? setUploadedImg(info.file.response.result.data.Location) : ' ';
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUploading(false);
        setuploadLogo(false);
      });
    }
  };
  const handleuploadChange = (info) => {
    if (info.file.status === 'uploading') {
      setImageUploading(true);
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      console.log(info.file);
      info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
      info.file ? setuploadVideo(info.file.response.result.data.Location) : ' ';
      getBase64(info.file.originFileObj, (url) => {
        setImageUploading(false);
        setLoading(false);
        setuplVid(false);
      });
    }
  };
  const handleuploadChange2 = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      console.log(info.file);
      info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
      info.file ? setuploadVideo(info.file.response.result.data.Location) : ' ';
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setuplVid(false);
      });
    }
  };
  console.log(uploadedImg);

  const beforeUpload = (file) => {
    console.log(file);
    if (file.type === 'image/jpeg' || file.type === 'image/png') {
      console.log('setting image type');
      setContentType('img');
    } else if (file.type === 'video/x-matroska' || file.type === 'video/mp4') setContentType('video');
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/x-matroska' || file.type === 'video/mp4';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    console.log('file Checked');
    const isLt2M = file.size / 1024 / 1024 < file.type === 'video/mp4' ? 200 : 20;
    if (!isLt2M) {
      setLargeFile(true);
      message.error('Image must smaller than 20MB!');
    }
    console.log('message');
    return isJpgOrPng && isLt2M;
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  const uploadData = async (userDetails) => {
    setLoading(true);

    try {
      console.log('uploadObj ', userDetails);
      const res = await axios.post(`${app.URL}/api/v1/admin/product/create`, userDetails, { headers: getHeaders() });
      setLoading(false);
       setShow(false);

      if (res.data.result.success) {
        console.log(res.data.result);
        setAddDescriptionResp(res.data.result);
        // setResetModal(true);
        message.success(res.data.result.msg);
        setTimeout(() => {
          navigate('/product/listing');
        }, 500);
      } else if (!res.data.result.success) {
       
          message.warning(res.data.result.msg);
      }
    } catch (err) {
    setLoading(false);
       setShow(false);

      err ? console.log(err.response.data.result) : '';
      err ? setErrorObj(err.response.data.result) : '';
      setTimeout(() => {
        setShow(false);
      }, 500);
      setResetModal(false);
      //   setAddDescriptionResp({code:"000"})
      if (err) console.log(err.response.data.message);
      else return;
    }
  };
  const onFinish = (values) => {
    console.log('Success:', values);
    // console.log('Success: JSON ', JSON.parse(values.customURL).contentWindow.document.body.innerHTML  );
    // console.log("customURL ", values.customURL.split("src=")[1].split(/[ >]/)[0])

    setUploadObj({
      productCode: values.productCode ? values.productCode : null,
      name: values.name ? values.name : null,
      unitPrice: values.unitPrice ? values.unitPrice : null,
      taxRate: values.taxRate ? values.taxRate : null,
      boxTypeId: values.boxTypeId ? values.boxTypeId : null,
      otherCharges: values.otherCharges ? values.otherCharges : null,
      description: values.description ? values.description : null,
      instruction: values.instruction ? values.instruction : null,
      productCategoryId: 1,
      // productCategoryId: values.productCategoryId ? values.productCategoryId : null,
      logoUrl: uploadedImg ? uploadedImg : null,
      videoUrl: customURL ? customVideoURL : uploadVideo,
      isCustomVideoUrl: customURL ? customURL : false,
      isActive: values.isActive ? values.isActive : null,
      cisPanelCode: values.cisPanelCode ? values.cisPanelCode : null,
      cisPanelName: values.cisPanelName ? values.cisPanelName : null,
      productTags: tags,
    });
    setResetModal(true);
    setShow(true);
  };
  console.log(uploadObj);
  const submitData = () => {
    console.log('calling: ', uploadObj);

    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }
  };
  const onChange = (checked) => {
    console.log(`switch to ${checked}`);
    setCustomURL(checked);
  };
  const handleClose = () => setShow(false);
  const handleActiveChange = (e) => {
    console.log(e.target.value);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const onVideoCustomURLChange = (e) => {
    let tempVideoURL = e.target.value ? e.target.value.split('src=')[1].split(/[ >]/)[0] : ' ';
    tempVideoURL = tempVideoURL ? tempVideoURL.slice(1, tempVideoURL.length - 1) : ' ';
    console.log(tempVideoURL);
    setCustomVideoURL(tempVideoURL);
    // setCustomVideoURL(e.target.value)
  };
  const handleNumberChange = (value) => {
    // Handle the number change
  };
  const handleKeyPress = (e) => {
    const keyCode = e.which || e.keyCode;
    if ((keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122)) {
      e.preventDefault();
    }
  };
  function goBack() {
    navigate('/product/listing', { replace: true });
  }
  window.addEventListener('popstate', goBack);

  // console.log(customVideoURL?customVideoURL.split("src=")[1].split(/[ >]/)[0]:" ");

  return (
    <div className='dashboard-card pb-5 container-fluid'>
      <div className='row p-0 pb-4'>
        <div className='for-before col-12 col-md-4 head fs-3 fw-bold' style={{ backgroundColor: '#a7c1d9', borderBottomRightRadius: '10px', color: '#FFFFFF' }}>
          Add Product
        </div>
      </div>
      <Form
        name='basic'
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
        initialValues={{
          remember: true,
          ['id']: 1,
          ['causename']: 'Hammad',
          ['isCustomVideoUrl']: false,
          ['isActive']: true,
        }}
        className='row p-5 px-3 pb-1'
      >
        <div className='col-md-8 col-12 input-column'>
          <div className='row'>
            <InputField
              col='col-lg-6'
              name='productCode'
              label='Product Code'
              rules={[
                {
                  required: true,
                  message: 'Enter Product Code',
                },
              ]}
              placeholder='Enter Product Code'
              required={true}
              maxLength={6}
            />
            <InputField
              col='col-lg-6'
              name='name'
              label='Product Name'
              rules={[
                {
                  required: true,
                  message: 'Enter Product Name',
                },
              ]}
              placeholder='Enter Product Name'
              required={true}
            />
            <InputField
              col='col-lg-6'
              name='unitPrice'
              label='Unit Price'
              rules={[
                {
                  required: true,
                  message: 'Enter Unit Price',
                },
              ]}
              placeholder='Enter Unit Price'
              required={true}
              onChange={handleKeyPress}
            />
            <SelectField
              options={boxTypes.map((item) => (
                <Select.Option value={item.boxTypeId}>{item.type}</Select.Option>
              ))}
              name='boxTypeId'
              label='Box Type'
              col='col-lg-6'
              required={true}
              rules={[
                {
                  required: true,
                  message: 'Select box type',
                },
              ]}
              placeholder='Select box type'
            />
            <InputField
              col='col-lg-6'
              name='cisPanelCode'
              label='CIS Panel Code'
              rules={[
                {
                  required: true,
                  message: 'Enter CIS Panel Code',
                },
              ]}
              placeholder='CIS Panel Code'
              required={true}
              onChange={handleKeyPress}
              maxLength={6}
            />
            <InputField
              col='col-lg-6'
              name='cisPanelName'
              label='CIS Panel Name'
              rules={[
                {
                  required: true,
                  message: 'Enter CIS Panel Name',
                },
              ]}
              placeholder='CIS Panel Name'
              required={true}
            />

            <TagInput tags={tags} setTags={setTags} />
            <TextAreaField
              rules={[
                {
                  message: 'Please Enter Desription',
                },
              ]}
              showCount={true}
              maxLength={1000}
              label='Product Description'
              required={true}
              col='col-lg-6'
              name='description'
              rows={4}
              placeholder='Enter Product Description'
            />
            <TextAreaField
              rules={[
                {
                  message: 'Please Enter Instruction',
                },
              ]}
              showCount={true}
              maxLength={1000}
              label='Product Instruction'
              required={true}
              col='col-lg-6'
              name='instruction'
              rows={4}
              placeholder='Enter Product Instruction'
            />
            <div className='col-md-12'>
              <Form.Item colon={false} valuePropName='checked' defaultValue={true} label='Active' name='isActive'>
                <Switch onChange={(e) => setisActive(e)} />
              </Form.Item>
            </div>
            <button onClick={goBack} type='primary' className={`btn btn-primary button patient-cancel-btn  col-md-4 mx-md-2 mr-2 mb-2`}>
              Cancel
            </button>

            <button type='primary' className={`btn btn-primary button col-md-4 mb-2`} htmlType='submit'>
              Save
            </button>
          </div>
        </div>
        <div className='col-md-3 col-12 order-last image-column'>
          <Form.Item valuePropName='fileList'>
            <Upload listType='picture-card' className='avatar-uploader' showUploadList={false} action={`${app.URL}/api/v1/general/product/logoUpload`} beforeUpload={beforeUpload} onChange={handleChange} headers={header}>
              {uploadedImg && !imageuploading ? (
                <img className='' src={uploadedImg} alt='avatar' />
              ) : !uploadedImg && imageuploading ? (
                <LoadingOutlined style={{ fontSize: '40px' }} />
              ) : (
                <>
                  <img className='for-add-img' src={AddPhoto} alt='avatar' />
                  <p className='add-text'>Upload Image</p>
                </>
              )}
            </Upload>
          </Form.Item>
          <small className='mt-2 font-weight-light' style={{ fontSize: '14px' }}>
            Note: Upload max image size 2MB with 280 x 280 px.
          </small>
          <div style={{ marginTop: '40px' }}>
            <Form.Item label='Custom URL' colon={false} valuePropName='checked' name='isCustomVideoUrl'>
              <Switch onChange={onChange} />
            </Form.Item>
            {!customURL ? (
              <Form.Item colon={false} name='video'>
                <Space
                  direction='vertical'
                  style={{
                    width: '100%',
                  }}
                  size='large'
                >
                  <Upload listType='picture' maxCount={1} className='avatar-uploader' headers={header} action={`${app.URL}/api/v1/general/product/videoUpload`} beforeUpload={beforeUpload} onChange={handleuploadChange2}>
                    <BTN icon={<UploadOutlined />} className={'upload-btn'} style={{ color: 'black' }}>
                      Upload Video
                    </BTN>
                    <div className='mt-2'>Note: Upload size for video is 20mb supported format for video are (mkv/mp4)</div>
                  </Upload>
                </Space>
              </Form.Item>
            ) : (
              <Form.Item
                name='customvideoURL'
                colon={false}
                onChange={onVideoCustomURLChange}
                rules={[
                  {
                    required: true,
                    message: 'Enter Last Name',
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  placeholder='<iframe width="420" height="275"
                          src="youtube.com"
                          title="YouTube video player" frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowfullscreen></iframe>'
                />
              </Form.Item>
            )}
          </div>
        </div>
      </Form>

      {addUserResp.code === 200 ? (
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>{addUserResp.message}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : addUserResp.code === 400 ? (
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Failed</Modal.Title>
          </Modal.Header>
          <Modal.Body>{addUserResp.data.message}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : (
        <Modal show={show} onHide={handleClose}>
          {/* <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header> */}
          <Modal.Body>Are you sure you want to add Product?</Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleClose}>
              Cancel
            </Button>
            <Button disabled={loading} variant='primary' htmlType='submit' onClick={submitData}>
              {loading ? <LoadingOutlined /> : 'Confirm'}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default AddProductsPrev;
